<app-checkout-layout
  [title]="sportsNumberTranslation"
  [description]="
    'participant_booking.birthday.sport.selection.text'
      | translate: { sportsNumber: sportsNumber }
  "
  [backLinkAriaLabel]="'checkout.birthday_sport.back_link' | translate"
  [backLink]="backLink"
>
  <form (ngSubmit)="onSubmit()">
    <div
      *ngFor="let sportForm of birthdaySportForm.controls; let isLast = last"
      [formGroup]="sportForm"
      class="relative gap-2 flex flex-col items-center"
      [class.mb-4]="!isLast"
      [class.mb-6]="isLast"
    >
      <div class="w-full">
        <app-form-checkbox
          formControlName="checked"
          [label]="sportForm.value.sport.name"
        ></app-form-checkbox>
      </div>
      <ng-container *ngFor="let item of sportItems">
        <ng-container *ngIf="item.name === sportForm.value.sport.name">
          <div class="w-full pl-6 text-grey-dark-1">
            <app-text-toggle
              [description]="item.description"
              [isOpen]="false"
              [maxCharacters]="90"
            ></app-text-toggle>
          </div>
        </ng-container>
      </ng-container>
      <div
        *ngIf="getSportImage(sportForm.value.sport.assetIdentifier) !== ''"
        class="birthday-sport-form__inner self-start ml-6 lg:absolute lg:cursor-pointer lg:ml-0"
      >
        <img
          class="birthday-sport-form__image max-w-28 rounded-4 lg:cursor-pointer"
          width="100"
          height="100"
          [src]="getSportImage(sportForm.value.sport.assetIdentifier)"
          alt=""
          (click)="showImageModal(sportForm.value.sport.assetIdentifier)"
        />
        <button
          app-vtmn-play-icon-button
          type="button"
          class="birthday-sport-form__inner__image-button"
          [size]="vtmnPlayIconButtonSize.SMALL"
          [variant]="vtmnPlayIconButtonVariant.PRIMARY"
        >
          <vtmn-play-icon [name]="icon?.Eye"></vtmn-play-icon>
        </button>
      </div>
    </div>

    <app-mobile-fixed-panel [parentElementRef]="elementRef">
      <button
        app-vtmn-play-button
        type="submit"
        [class.w-full]="isMobileDevice"
        [type]="ctaButtonType.Submit"
        [size]="vtmnPlayButtonSize.MEDIUM"
        [shape]="
          isMobileDevice
            ? vtmnPlayButtonShape.SQUARED
            : vtmnPlayButtonShape.ROUNDED
        "
        [disabled]="isDisable ? true : null"
        [attr.data-disabled]="isDisable ? true : null"
        data-test="input-submit-birthday-sport-form"
      >
        {{ 'checkout.birthday_sport.button' | translate }}
      </button>
    </app-mobile-fixed-panel>
  </form>
  <app-modal
    class="activity-component__modal"
    (modalClose)="this.sportModal.hide()"
  >
    <div modal-content class="m-4 md:flex">
      <img [src]="imageUrl" loading="lazy" alt="" />
    </div>
  </app-modal>
</app-checkout-layout>
